import {SpeciesActivityTitle} from "./Types/SpeciesActivityTitle";
import {DefaultActivityTitle} from "./Types/DefaultActivityTitle";
import {SurveyAnswersFieldViewer} from "../../../Models/Core/FieldViewers";
import {getActivityLineDescription} from "./ActivityLineRegistry";
import {parseActivityData} from "../../../Utils/Activity/parseActivityData";

export class ActivityFeedEventRenderFactory {
    static getContextForActivity(eventTypes, activity) {
        const titleRenderer = ActivityFeedEventRenderFactory.getTitleForActivity(eventTypes, activity);
        const descriptionRenderer = ActivityFeedEventRenderFactory.getDescriptionForActivity(eventTypes, activity);
        const secondaryDescription = ActivityFeedEventRenderFactory.getSecondaryDescriptionForActivity(eventTypes, activity);

        return {
            title: titleRenderer ?? undefined,
            description: descriptionRenderer ?? null,
            secondaryDescription: secondaryDescription ?? null,
            valid: !!descriptionRenderer
        };
    }

    // returns a component or string description
    static getTitleForActivity(eventTypes, activity) {
        let eventType = ActivityFeedEventRenderFactory.getTypeForActivity(eventTypes, activity);

        switch (eventType?.code) {
            case "create_species":
                // fallthrough
            case "deny_species":
                // fallthrough
            case "delete_species":
                // fallthrough
            case "update_species":
                return SpeciesActivityTitle;
            default:
                return DefaultActivityTitle;
        }
    }

    // The right-hand pane, which is a column of its own rather than part of the description. Only
    // the survey answers pane is named here; every other type that shows a before/after gets it from
    // ActivityFeedItem's own delta fallback, which triggers on the row carrying a viewer.
    static getSecondaryDescriptionForActivity(eventTypes, activity) {
        let eventType = ActivityFeedEventRenderFactory.getTypeForActivity(eventTypes, activity);

        switch (eventType?.code) {
            case "survey_transaction_create":
                return SurveyAnswersFieldViewer;
            default:
                return null;
        }
    }

    // returns a component or string description
    static getDescriptionForActivity(eventTypes, activity) {
        let eventType = ActivityFeedEventRenderFactory.getTypeForActivity(eventTypes, activity);

        // Every activity type is described by the shared line grammar, so this is the whole of the
        // lookup — the per-type switch that used to follow, one bespoke sentence renderer per type,
        // is gone. Null means either that the code is not in the registry, which the preflight
        // coverage check fails on rather than leaving to be noticed as a blank feed row, or that the
        // type has judged this particular row not worth reporting; `getContextForActivity` turns
        // either into `valid: false` and `ActivityFeedGroup` omits the entry.
        return getActivityLineDescription(
            eventType?.code,
            {data: parseActivityData(activity?.Activity), event: activity}
        );
    }

    static getTypeForActivity(eventTypes, activity) {
        if(eventTypes && eventTypes.length) {
            return eventTypes.find((x) => x.activityTypeId === activity.Activity.activityTypeId);
        }

        return null;
    }
}
